import { gql } from "@apollo/client"

export const MUTATION_CREATE_BIOMETRIC_REGISTRATION = gql`
  mutation CreateApplicationForm(
    $firstName: String!
    $lastName: String!
    $phoneNumber: String!
    $secondaryPhoneNumber: String!
    $optionalPhoneNumber: String
    $stateId: Int!
    $citiesId: String!
    $termsAndConditionsAcceptedId: String!
    $email: String!
    $neighborhood: String
    $step: String!
    $rumvNumber: String
    $helpType: String
    $token: String!
  ) {
    createApplicationForm(
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      secondaryPhoneNumber: $secondaryPhoneNumber
      optionalPhoneNumber: $optionalPhoneNumber
      stateId: $stateId
      citiesId: $citiesId
      termsAndConditionsAcceptedId: $termsAndConditionsAcceptedId
      email: $email
      neighborhood: $neighborhood
      step: $step
      rumvNumber: $rumvNumber
      helpType: $helpType
      token: $token
    ) {
      message
      data {
        id
      }
    }
  }
`
